namespace SP {
    export interface IncommingInfo {
        sender: string;
        referenceNo: string;
        date: string;
        type: string;
        quantity: number;
    }


    export interface ItemLocationInfo {
        total: number;
        reserved: number;
        incomming: IncommingInfo[]
    }


    export interface ItemInfo {
        id: string;
        sku: string;
        supplierNumber: string;
        itemType: ItemType;
        inOrderCount: number;
        totalCombined: number;
        reservedCombined: number;
        incommingCombined: number;

        assemblableQuantity: number;
        disassemblableQuantity: number;

        collectionAllowDisassembly: boolean;
        collectionAllowAssembly: boolean;

        locations: { [locationKey: string]: ItemLocationInfo };
        refillLimit: number;
        refillMax: number;
        maxPickPlacements: number;
        refillParked: boolean;
        description: string;
        manufacturerName: string;
        modelNo: string;
        imageUrl: string;
        unNumber: string;
        fragile: boolean;
        expirable: boolean;
        useProductionDate: boolean;
        unitType: UnitType;
        width: number;
        height: number;
        debth: number;
        weight: number;
        warehouseWeight: number;
        warehouseNotificationPacker: string;
        warehouseNotificationPicker: string;
        barcodes: string[];
        additionalBarcodes: { [barcode: string]: number };
        allBarcodes: { [barcode: string]: number };
        countryOfOrigin: string;
        tariffCode: string;
        countryTariffCodes: { [country: string]: string };
        preferredStockPlacementId: number;
        preferredStockPlacementData: string;
        customerId: string;
       // stockId: string;
        importPlacementName: string;

        allowBatchMixing: boolean;
        allowDropshipping: boolean;
        registerSerialNumber: boolean;
        useBatchNumber: boolean;
        useFifo: boolean;

        abc_orders: string;
        abc_units: string;
        abc_profit: string;

        normalPrice: number;
        salePrice: number;
    }
}